export const IconRegNumber = (props: IconClip) => {
	return (
		<svg
			width={props.width ?? 16}
			height={props.height ?? 16}
			viewBox="0 0 24 24"
			fill="none"
			stroke={props.color ?? "#d9dfe9"}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round">
			<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
			<polyline points="14 2 14 8 20 8" />
			<line x1="16" y1="13" x2="8" y2="13" />
			<line x1="16" y1="17" x2="8" y2="17" />
		</svg>
	);
};
